import { useNavigate, useSearch } from '@tanstack/react-router';

/**
 * Filtre « Origine » d'une liste — successeur du sélecteur de boutique global.
 * Sa valeur vit dans l'URL, absente = « Toutes les origines ». Le paramètre
 * reste nommé `store` : c'est le nom attendu par les API de liste, et les
 * liens existants (alertes, tableau de bord) continuent de fonctionner.
 *
 * Générique par construction (`useSearch({strict:false})`) : n'importe quel
 * écran peut l'utiliser sans que ce module connaisse sa route. Un écran qui
 * veut ce filtre ajoute `store: z.string().optional()` à son propre schéma
 * `validateSearch` (voir `README-shell.md`).
 */
export const ORIGIN_SEARCH_PARAM = 'store';

export interface UseOriginFilterResult {
  /** `null` = « Toutes les origines ». */
  origin: string | null;
  setOrigin: (next: string | null) => void;
}

export function useOriginFilter(): UseOriginFilterResult {
  const search: unknown = useSearch({ strict: false });
  const navigate = useNavigate();

  const raw =
    typeof search === 'object' && search !== null
      ? (search as Record<string, unknown>)[ORIGIN_SEARCH_PARAM]
      : undefined;
  const origin = typeof raw === 'string' && raw.length > 0 ? raw : null;

  function setOrigin(next: string | null): void {
    void navigate({
      to: '.',
      search: (prev: Record<string, unknown>) => ({
        ...prev,
        [ORIGIN_SEARCH_PARAM]: next ?? undefined,
      }),
      replace: true,
    });
  }

  return { origin, setOrigin };
}
